import { GetAllReportResponseSchema } from '@shared/schema/reporting.get-all.schema.'
import { queryOptions } from '@tanstack/react-query'

import { type QueryOptionsData } from '@/@types/query'
import { type SiteId } from '@/@types/site'
import { apiFetch } from '@/lib/api-fetch'

export function reportsQuery(siteId: SiteId) {
  return queryOptions({
    queryKey: ['site', siteId, 'reports'],
    async queryFn() {
      const rawResponse = await apiFetch.get(`site/${siteId}/report`)
      if (!rawResponse.ok) {
        throw new Error(`Failed to fetch reports for site ${siteId}`)
      }

      try {
        return await GetAllReportResponseSchema.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse reports response', { cause: error })
      }
    },
  })
}

export type Report = QueryOptionsData<typeof reportsQuery>[number]
